import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';

export type GroupState = {
  group: string;
};

export const defaultGroupState: GroupState = {
  group: ''
};

export const groupSlice = createSlice({
  name: 'group',
  initialState: defaultGroupState,
  reducers: {
    setGroup: (state, action: PayloadAction<string | null>) => {
      state.group = action.payload ?? '';
    }
  }
});

export const { setGroup } = groupSlice.actions;

export const groupReducer = groupSlice.reducer;

export const groupSelector = (state: RootState) => state.group;
